import { useCallback, useRef } from "react"

export const useScroll = (callback) => {
  const executing = useRef(false)
  const scrollTop = useRef(0)
  const scrollDiff = useRef(0)
  const scrollCountDown = useRef(0)

  const triggerExecution = useCallback(
    (event) => {
      if (typeof callback === "function") {
        callback({
          scrollTop: scrollTop.current,
          scrollDiff: scrollDiff.current,
          scrollCountDown: scrollCountDown.current,
        })
        executing.current = false
      }
    },
    [callback],
  )

  const handleScroll = useCallback(
    (event) => {
      if (!executing.current) {
        scrollDiff.current = event.target.scrollTop - scrollTop.current
        scrollTop.current = event.target.scrollTop
        scrollCountDown.current = event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop
        requestAnimationFrame(triggerExecution)
      }
      executing.current = true
    },
    [triggerExecution],
  )

  return { handleScroll }
}
